var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25654",
    transform: "translate(-320 -139)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(320.5 139.5)",
    style: {
      fill: "#fff",
      stroke: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13633",
    d: "M277.5 14.5h21a3.009 3.009 0 0 1 3 3v21a3.009 3.009 0 0 1-3 3h-21a3.009 3.009 0 0 1-3-3v-21a3.009 3.009 0 0 1 3-3zm5.4 15.8-3 4a.75.75 0 0 0 .6 1.2h15a.75.75 0 0 0 .6-1.2l-4.125-5.5a.744.744 0 0 0-1.2 0l-3.9 5.2-2.775-3.7a.744.744 0 0 0-1.2 0z",
    transform: "translate(60.5 139.5)",
    style: {
      fill: "#ae20ae",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNormal);
export default __webpack_public_path__ + "static/media/image-normal.78c49dd12886cf05b6853054ad841782.svg";
export { ForwardRef as ReactComponent };